import { recaptchaActionNames } from "@recaptcha/config/actionNames";
import useHandleRecaptcha from "@recaptcha/useHandleRecaptchaV3";
import useSendSetPasswordEmail from "clientState/AuthFlow/hooks/SendSetPasswordEmail/useSendSetPasswordEmail";

import type {
  SendSetPasswordEmailType,
  UseForgotPasswordType,
} from "./contract";

export const useForgotPassword: UseForgotPasswordType = () => {
  const { SIGNUP } = recaptchaActionNames;

  const handleRecaptcha = useHandleRecaptcha(SIGNUP);

  const { mutate } = useSendSetPasswordEmail();

  const sendSetPasswordEmail: SendSetPasswordEmailType = async ({
    email,
    landingPagePath,
    newsletterSubscribed,
    onSuccess,
    onError,
  }) => {
    await handleRecaptcha();
    mutate(
      { request: { email, landingPagePath, newsletterSubscribed } },
      {
        onSuccess: ({ data, variables }) => {
          onSuccess({
            email: variables.request.email,
            acknowledged: data.sendSetPasswordEmail.acknowledged,
          });
        },
        onError: () => {
          onError();
        },
      },
    );
  };

  return {
    sendSetPasswordEmail,
  };
};
